import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Popover } from 'antd';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../pages/admin/admin_assets/css/Profile.css';
import '../../../pages/admin/admin_assets/css/Setting.css';
import '../../../pages/admin/admin_assets/css/UserManagement.css';
import three_dots from '../../../pages/admin/admin_assets/img/three_dots.svg';
import config from '../../../config/config.js';
// import OverlayTrigger from 'react-bootstrap/OverlayTrigger';


  // Modal to Add New Member and Send Invite
  function MyVerticallyCenteredModal({ show, onHide, fetchData }) {
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('User'); // default to 'Admin'
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [companyName, setCompanyName] = useState('');
    const [name, setName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setIsSubmitting(true);
    
      // Basic validation for required fields
      if (!email || !name || !companyName || !phoneNumber) {
        toast.error('All fields are required');
        setIsSubmitting(false);
        return;
      }
    
      // Ensure the email is valid
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        toast.error('Please enter a valid email address');
        setIsSubmitting(false);
        return;
      }
    
      try {
        const response = await fetch(`${config.API_BASE_URL}/add_account_user.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email,
            role,
            company_name: companyName,
            name,
            phone: phoneNumber,
            password: 'h8U#zP@tQ7wLx2&1BzM9', // Optional: Set a temporary password or handle it dynamically
          }),
        });
    
        const result = await response.json();
    
        if (response.ok && result.message) {
          // If the response is OK and the backend returns a success message
          toast.success('New member added successfully and invitation email sent!');
          onHide();
          fetchData(); // Refresh data after adding a user
        } else {
          // If the response is not OK or there is an error message from the backend
          toast.error(result.error || 'Failed to add user');
        }
      } catch (error) {
        // Catch network or unexpected errors
        toast.error('An error occurred while adding user');
        console.error('Error:', error);
      } finally {
        setIsSubmitting(false);
      }
    };
    
    
    
  
    return (
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className='user_management_popup'
      >
        <Modal.Body>
          <h4>Add New Member</h4>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="cname">
              <Form.Label>Company Name <sup><i className="bi bi-asterisk" style={{color:"#DE0A0C"}}></i></sup></Form.Label>
              <Form.Control
                type="cname"
                placeholder="Enter company name"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
              />
            </Form.Group>
  
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>Name <sup><i className="bi bi-asterisk" style={{color:"#DE0A0C"}}></i></sup></Form.Label>
              <Form.Control
                type="name"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </Form.Group>
  
            <Form.Group className="mb-3" controlId="email">
  <Form.Label>Email address <sup><i className="bi bi-asterisk" style={{color:"#DE0A0C"}}></i></sup></Form.Label>
  <Form.Control
    type="email"
    placeholder="Enter email address"
    value={email}
    onChange={(e) => {
      // Basic trimming to avoid leading/trailing spaces
      const formattedEmail = e.target.value.trim();
      setEmail(formattedEmail);
    }}
    required
  />
</Form.Group>

  
            <Form.Group className="mb-3" controlId="pnumber">
  <Form.Label>Phone Number <sup><i className="bi bi-asterisk" style={{color:"#DE0A0C"}}></i></sup></Form.Label>
  <Form.Control
    type="text" // Change to "text" to allow custom validation
    placeholder="Enter phone number"
    value={phoneNumber}
    onChange={(e) => {
      // Allow only numbers and the '+' symbol
      const formattedValue = e.target.value.replace(/[^0-9+]/g, '');
      setPhoneNumber(formattedValue);
    }}
    required
  />
</Form.Group>

          </Form>
        </Modal.Body>
        <Modal.Footer className='border-0'>
          <Button type="submit" disabled={isSubmitting} onClick={handleSubmit}>
            {isSubmitting ? 'Adding...' : 'Add'}
          </Button>
          <Button onClick={onHide}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    );
  }
  
  // Popup to Confirm User Suspension
  // Popup to Confirm User Suspension
function SuspendPopUp({ show, onHide, onConfirm, userId }) {
  const [isSuspending, setIsSuspending] = useState(false);

  const handleSuspend = async () => {
    setIsSuspending(true);
    try {
      const response = await fetch(`${config.API_BASE_URL}/suspend_account_user.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `id=${userId}`, // Pass the userId as part of the request
      });

      const result = await response.json();

      if (result.message) {
        toast.success(result.message); // Show success toast
        onConfirm(); // Callback to update state in the parent (AccountTab)
        onHide(); // Close the popup
      } else {
        toast.error(result.error || 'An error occurred.');
      }
    } catch (error) {
      toast.error('Failed to suspend user.');
      console.error('Error suspending user:', error);
    } finally {
      setIsSuspending(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static" centered className='yes_cancel'>
      <Modal.Body>
        <div className="confirm-removal-modal">
          <div className="confirm-removal-content">
            <h4>Confirm User Suspension</h4>
            <p>Are you sure you want to suspend this user? They will be temporarily blocked from accessing their account, but their data will remain intact.</p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className='border-0'>
        <Button onClick={handleSuspend} disabled={isSuspending}>
          {isSuspending ? 'Suspending...' : 'Yes, Suspend User'}
        </Button>
        <Button onClick={onHide}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  );
}


  // Popup to Confirm User Removal
  function RemovePopUp({ show, onHide, onConfirm, userId }) {
    const [isRemoving, setIsRemoving] = useState(false);
  
    const handleRemove = async () => {
      setIsRemoving(true);
      try {
        const response = await fetch(`${config.API_BASE_URL}/remove_account_user.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: `id=${userId}`, // Pass the userId as part of the request
        });
  
        const result = await response.json();
  
        if (result.message) {
          toast.success(result.message); // Show success toast
          onConfirm(); // Callback to update state in the parent (AccountTab)
          onHide(); // Close the popup
        } else {
          toast.error(result.error || 'An error occurred.');
        }
      } catch (error) {
        toast.error('Failed to remove user.');
        console.error('Error removing user:', error);
      } finally {
        setIsRemoving(false);
      }
    };
  
    return (
      <Modal show={show} onHide={onHide} size="lg" backdrop="static" centered className='yes_cancel'>
        <Modal.Body>
          <div className="confirm-removal-modal">
            <div className="confirm-removal-content">
              <h4>Confirm User Removal</h4>
              <p>Are you sure you want to permanently remove this user? This action cannot be undone, and the user will lose all access to the platform.</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className='border-0'>
          <Button onClick={handleRemove} disabled={isRemoving}>
            {isRemoving ? 'Removing...' : 'Yes, Remove User'}
          </Button>
          <Button onClick={onHide}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    );
  }
  


  const AccountTab = () => {
    const [accountData, setAccountData] = useState([]);
    const [removePopUpShow, setRemovePopUpShow] = useState(false);
    const [suspendPopUpShow, setSuspendPopUpShow] = useState(false); // Fixed variable name
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [activeTab, setActiveTab] = useState('admin');
    const [modalShow, setModalShow] = useState(false);
  
    // Fetch data from the backend
    const fetchData = async () => {
      try {
        const response = await fetch(`${config.API_BASE_URL}/get_account_users.php`); // Replace with your PHP backend URL
        const data = await response.json();
        if (Array.isArray(data)) {
          setAccountData(data);
        } else {
          toast.error('Failed to load data.');
        }
      } catch (error) {
        toast.error('Error fetching data from the server.');
        console.error('Error fetching data:', error);
      }
    };
  
    useEffect(() => {
      fetchData(); // Fetch data on component mount
    }, []); // Empty dependency array ensures it runs only once on component mount
  
    // Handle tab click to change active tab
    const handleTabClick = (tabname) => {
      setActiveTab(tabname);
    };
  
    const handleSuspendUser = (userId) => {
      setSelectedUserId(userId);
      setSuspendPopUpShow(true);
    };
  
    const handleRemoveUser = (userId) => {
      setSelectedUserId(userId);
      setRemovePopUpShow(true); // Trigger the popup
    };
    
  
    return (
      <div>
        <div className="mb-5 container-fluid admin_usermanagement user_management py-0">
          <div className="d-flex export_data_config">
            <Button className="exportbutton new_rule" onClick={() => setModalShow(true)}>
              <p><i className="addicon bi bi-plus-circle"></i>Add New Member</p>
            </Button>
          </div>
  
          <div className="result_activity_log user_table_sec d-flex justify-content-between w-100">
            <div id="configtable" className="table-container top_space accout_table">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Company Name</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone Number</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                {accountData.length > 0 ? (
                  accountData.map((data, index) => (
                    <tr key={data.id}>
                      <td>{index + 1}</td> {/* Serial number as index + 1 */}
                      <td>{data.company_name}</td>
                      <td>{data.name}</td>
                      <td>{data.email}</td>
                      <td>{data.phone}</td>
                      <td>{data.status}</td>
                      <td>
                        <Popover
                          content={
                            <div className="over_btns">
                              {data.status !== 'Suspended' && (
                                <button onClick={() => { setSuspendPopUpShow(true); handleSuspendUser(data.id) }}>
                                  Suspend
                                </button>
                              )}
                              <hr />
                              <button onClick={() => handleRemoveUser(data.id)}>Remove</button>
                            </div>
                          }
                          trigger="click"
                          placement="right"
                        >
                          <div className="dot_over">
                            <img src={three_dots} alt="" />
                          </div>
                        </Popover>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan="7">No Data Available</td></tr>
                )}
              </tbody>

              </table>
            </div>
          </div>
        </div>
  
        {/* Popups */}
        <SuspendPopUp
          show={suspendPopUpShow}
          onHide={() => setSuspendPopUpShow(false)}
          onConfirm={fetchData} // Refresh data after suspension
          userId={selectedUserId} // Pass the selected user ID
        />
        <RemovePopUp
  show={removePopUpShow}
  onHide={() => setRemovePopUpShow(false)}
  onConfirm={fetchData} // Refresh data after removal
  userId={selectedUserId} // Pass the selected user ID
/>

  
<MyVerticallyCenteredModal
  show={modalShow}
  onHide={() => setModalShow(false)}
  fetchData={fetchData}  // Pass fetchData as a prop
/>

      </div>
    );
  };
  
  export default AccountTab;
  